import { faShareSquare } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {  useNavigate } from "react-router-dom"
import './index.scss'
export const MenuSection = ({ item }: any) => {
    const navigate = useNavigate();
    return <div className='menu-section'>
        <div className='menu-item'>
            <div className="icon"><FontAwesomeIcon className="white-label" icon={faShareSquare} /></div>
            <div className="menu-label">  {item.name}</div>
        </div>
        {
            item.children.map((opt: any) => {
                return (<div key={opt.name} className='menu-section'>
                    <div onClick={() => {
                        navigate(`/${opt.route}`)
                    }} className='menu-item children'>
                        <div className="icon"><FontAwesomeIcon className="white-label" icon={faShareSquare} /></div>
                        <div className="menu-label">
                            {opt.name}
                            {/* <Link to={`/${opt.route}`}>{opt.name}</Link> */}
                        </div>
                    </div>
                </div>);
            })
        }

    </div>
}

